import React, { useMemo, useRef } from "react";
import { TreeSelectContext } from "./TreeSelectContext";
import { TreeSelectItem } from "./TreeSelectItem";
import { useState } from "react";
import "./TreeSelect.scss";
import cs from "classnames";
import { useOnClickOutside } from "../DateRange/outside";
import { getVisibleItems } from "./get-visible-items";

export const TreeSelect = ({ value, onChange, items }) => {
  const wrapperRef = useRef();

  const [expandedIds, setExpandedIds] = useState([]);

  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggle = () => {
    setIsExpanded(prevState => !prevState);
  };

  const handleCollapse = () => {
    setIsExpanded(false);
  };

  const handleExpand = id =>
    setExpandedIds(prevState =>
      prevState.includes(id)
        ? prevState.filter(it => it !== id)
        : [...prevState, id]
    );

  const defaultItems = getVisibleItems(
    items.filter(item => !item.parent),
    value
  );

  useOnClickOutside(wrapperRef, () => handleCollapse());

  const label = useMemo(() => {
    if (!value || value.length === 0) {
      return "Выбор категорий таксономии";
    }

    return items
      .filter(item => value.includes(item.value))
      .map(item => item.label)
      .join(",");
  }, [value, items]);

  return (
    <TreeSelectContext.Provider
      value={{
        value,
        onChange,
        expandedIds,
        onExpand: handleExpand
      }}
    >
      <div
        ref={wrapperRef}
        className={cs("tree-select", { ["tree-select_expanded"]: isExpanded })}
      >
        <div className={"tree-select__toggle"} onClick={handleToggle}>
          <span
            style={{
              marginRight: 24,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis"
            }}
          >
            {label}
          </span>
          <span className={"tree-select__indicator"}></span>
        </div>
        {isExpanded && (
          <div className={"tree-select__items"}>
            {defaultItems.map(({ label, value, ...item }) => {
              return (
                <TreeSelectItem
                  key={value}
                  value={value}
                  items={items}
                  {...item}
                >
                  {label}
                </TreeSelectItem>
              );
            })}
          </div>
        )}
      </div>
    </TreeSelectContext.Provider>
  );
};
